<template>
  <div id="wrap"></div>
</template>

<script>
import AppConst from "@utils/app-const";

export default {
  name: "Secret",
  mixins: [],
  components: {},
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {},
  methods: {},
  mounted() {
    // URLパラメータで渡されたシークレットキーをストアに保存してIndexに遷移
    var key = this.$route.params.key ?? "";
    console.log("Secret Param", this.$route.params.key);
    this.$store.commit("secretKey", key);
    this.$router.replace({ name: AppConst.ROUTENM.INDEX });
  },
};
</script>
